// import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import stats from "../../assets/images/dashboard/wege_new_logo.png";
import LoginTabset from "./loginTabset";

const Login = () => {
  const navigate = useNavigate();
  const hisCookie = Cookies.get("logss");
  const { t } = useTranslation();
  useEffect(() => {
    if (hisCookie) {
      navigate("/dashboard");
    }
  }, [hisCookie, navigate]);
  return (
    <Fragment>
      {!hisCookie && (
        <div className="page-wrapper">
          <div className="authentication-box">
            <Container>
              <Row>
                <Col className="col-md-5 p-0 card-left">
                  <Card className="bg-login">
                    <div className="svg-icon">
                      <img alt="" src={stats} className="Img-fluid" />
                    </div>

                    <div>
                      <div>
                        <h3>{t("WelcomeMessage")}</h3>
                        <p>{t("WelcomeMessage2")}</p>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col className="col-md-7 p-0 card-right">
                  <Card className="tab2-card">
                    <CardBody>
                      <LoginTabset />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Login;
